import React from "react";

// Extracted from the identical CustomLegend copy-pasted in
// GemstoneReportsColorComp/SizeComp/PriceComp/ClarityComp.
const CustomLegend = ({ chartData, colorData }) => {
  if (!chartData?.length || chartData.length <= 1) return null;

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        marginBottom: "10px",
      }}
    >
      {chartData.slice(1).map((row, index) => (
        <div
          key={index}
          style={{
            display: "flex",
            alignItems: "center",
            margin: "4px 8px",
            fontSize: "13px",
            fontWeight: "500",
          }}
        >
          <div
            style={{
              width: "14px",
              height: "14px",
              backgroundColor: colorData[index],
              marginRight: "6px",
              borderRadius: "3px",
            }}
          ></div>
          {row[0].replace(/\s*\([^)]*\)\s*/g, "")} ({row[1]})
        </div>
      ))}
    </div>
  );
};

export default CustomLegend;
